// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapdiv {
  width: 100%;
}

.mapdiv path {
  fill: #a5a5a5;
  stroke: #ffffff;
  stroke-width: 4px;
  transition: fill 0.3s;
}

.mapdiv :hover {
  fill: #f48706;
}

.border {
  border-top: 1px solid #707070 !important;
}

._padd {
  padding: 10px 15px 8px 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/Map/index.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AACA;EACA,wCAAA;AAEA;;AAAA;EACI,2BAAA;AAGJ","sourcesContent":[".mapdiv{\n    width: 100%;\n}\n\n.mapdiv path {\n    fill: #a5a5a5;\n    stroke: #ffffff;\n    stroke-width: 4px;\n    transition: fill 0.3s;\n}\n\n.mapdiv :hover {\n    fill: #f48706;\n}\n.border{\nborder-top: 1px solid #707070 !important;\n}\n._padd{\n    padding: 10px 15px 8px 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
